import { useLocation } from 'react-router'
import { CardSkeleton } from '@/components/layout/card-skeleton'
import { AppDeploymentTabFallback } from '@/routes/app/tabs/deployment/fallback'
import { AppDeploymentsTabFallback } from '@/routes/app/tabs/deployments/fallback'
import { OverviewTabFallback } from '@/routes/app/tabs/overview/fallback'
import { AppRuntimeLogsTabFallback } from '@/routes/app/tabs/runtime-logs/fallback'

export const AppPageFallback = () => {
  const location = useLocation()

  if (location.pathname.includes('/overview')) {
    return <OverviewTabFallback />
  }

  if (location.pathname.includes('/deployments')) {
    return <AppDeploymentsTabFallback />
  }

  if (location.pathname.includes('/deployment/')) {
    return <AppDeploymentTabFallback />
  }

  if (location.pathname.includes('/logs')) {
    return <AppRuntimeLogsTabFallback />
  }

  return <CardSkeleton />
}
